<div [class]="itemClass()" (click)="onClick()" (keyup.enter)="onClick()" tabindex="0" role="button">
  <div class="notification-item__icon">
    <i [class]="notification().iconClass"></i>
  </div>

  <div class="notification-item__body">
    <div class="notification-item__title">
      {{ notification().titleKey | transloco:notification().translationParams }}
    </div>
    <div class="notification-item__message">
      {{ notification().messageKey | transloco:notification().translationParams }}
    </div>
    <div class="notification-item__meta">
      <span class="notification-item__time" [pTooltip]="notification().formattedDate">
        {{ notification().relativeTime }}
      </span>
    </div>
  </div>

  @if (notification().isUnread) {
    <button
      type="button"
      pButton
      icon="pi pi-check"
      class="notification-item__action"
      severity="secondary"
      [text]="true"
      [rounded]="true"
      [pTooltip]="'notifications.markAsRead' | transloco"
      (click)="onMarkRead($event)">
    </button>
  }
</div>
